<template>
    <v-container
      class="fill-height py-0"
      fluid
    >
      <v-row
        align="center"
        justify="center"
      >
        <v-col
          cols="12"
          sm="8"
          md="4"
          class="pa-0"
        >
          <v-img usemap="" class="image hotspot" contain :src="image" max-width="100%" id="hotspot">
              <img :src="logo" class="overlay-logo" />
          </v-img>
          <v-card class="elevation-0 login--card" color="rgba(0, 0, 0, 0)">
            <v-card-text class="login--fieldbg text-center white--text subtitle-1">
              You are logged out. Please use the personalized login link that we sent to your email to access your lead.
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
</template>

<script>
    import image from "@/assets/portrait.jpg"
    import logo from "@/assets/logo.png"

    export default {
        data: () => ({
            loading: false,
            image: image,
            logo: logo
        }),
        created() {
          console.log('test')
        },
        methods: {

        }
    }
</script>

<style lang="sass">   
img
  &.overlay-logo 
    position: absolute
    top: 24%
    width: 250px
    left: 50%
    transform: translate(-50%)

main
  &.v-content
    &.Home 
      background: #0655b8

.transitionBG 
  position: fixed
  top: 0
  left: 0
  height: 100%
  width: 100%
  background: #000
  z-index: 9999999999
  
.login--card
  position: absolute
  top: 38%
  left: 50%
  width: 70%
  transform: translateX(-50%)
  max-width: 300px

.login--fieldbg 
  background: rgb(0, 57, 110)
  border-radius: 5px

button
  &.access--btn
    font-size: 30px!important
    color: #00396e!important
    letter-spacing: 0
    margin-top: 10px
    font-family: 'Pyxel'!important

.v-toolbar__title
  &.display-1
    &.text-uppercase
      &.font-weight-black
        &.sub--title 
          &.login--title
            font-size: 36px!important
            line-height: 1em!important
            letter-spacing: 0!important
            font-family: Pyxel!important
            margin-bottom: 15px!important

.title--toolbar 
  .v-toolbar__content 
    padding-left: 0
    padding-right: 0
</style>